// extracted by mini-css-extract-plugin
export default {"actionIcons":"ee7066b34f7c"};